// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchPanelBaseAnt {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #d6e2f5;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);
}

.searchPanelBaseAnt__searchBtn.ant-btn {
  min-width: 52px;
  height: auto;
  border: 0 !important;
  border-right: 1px solid #dbe6f8 !important;
  border-radius: 0;
  color: #5f6f88;
  background: linear-gradient(180deg, #f7faff 0%, #f2f6fd 100%);
  box-shadow: none;
}
.searchPanelBaseAnt__searchBtn.ant-btn .anticon {
  font-size: 18px;
}
.searchPanelBaseAnt__searchBtn.ant-btn:hover, .searchPanelBaseAnt__searchBtn.ant-btn:focus {
  color: #20baf2 !important;
  background: linear-gradient(180deg, #f4f8ff 0%, #ecf3ff 100%) !important;
}

.searchPanelBaseAnt__input.ant-input {
  border: 0 !important;
  border-radius: 0;
  height: auto;
  min-height: 50px;
  padding: 0 14px;
  font-size: 15px;
  color: #2f415f;
  box-shadow: none !important;
}
.searchPanelBaseAnt__input.ant-input::placeholder {
  color: #9aa8bc;
  opacity: 1;
}
.searchPanelBaseAnt__input.ant-input:hover, .searchPanelBaseAnt__input.ant-input:focus {
  border: 0 !important;
  box-shadow: none !important;
}

.searchPanelBaseAnt__config {
  display: inline-flex;
  align-items: stretch;
  border-left: 1px solid #dbe6f8;
  padding: 0;
}
.searchPanelBaseAnt__config .catalogControlAnt__iconBtn.ant-btn {
  min-width: 50px;
  height: auto;
  border: 0 !important;
  border-radius: 0;
  box-shadow: none;
  background: linear-gradient(180deg, #f7faff 0%, #f2f6fd 100%);
}

@media screen and (max-width: 767.98px) {
  .searchPanelBaseAnt__searchBtn.ant-btn {
    min-width: 46px;
  }
  .searchPanelBaseAnt__searchBtn.ant-btn .anticon {
    font-size: 16px;
  }
  .searchPanelBaseAnt__input.ant-input {
    min-height: 44px;
    padding: 0 12px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/searchPanel/SearchPanelBase.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oDAAA;AACF;;AACA;EACE,eAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;EACA,6DAAA;EACA,gBAAA;AAEF;AAAE;EACE,eAAA;AAEJ;AAAE;EAEE,yBAAA;EACA,wEAAA;AACJ;;AACA;EACE,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AAEF;AAAE;EACE,cAAA;EACA,UAAA;AAEJ;AAAE;EAEE,oBAAA;EACA,2BAAA;AACJ;;AACA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;AAEF;AAAE;EACE,eAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6DAAA;AAEJ;;AAAA;EACE;IACE,eAAA;EAGF;EADE;IACE,eAAA;EAGJ;EADA;IACE,gBAAA;IACA,eAAA;IACA,eAAA;EAGF;AACF","sourcesContent":[".searchPanelBaseAnt\n  display: flex\n  align-items: stretch\n  width: 100%\n  border: 1px solid #d6e2f5\n  border-radius: 14px\n  overflow: hidden\n  background: #ffffff\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6)\n\n.searchPanelBaseAnt__searchBtn.ant-btn\n  min-width: 52px\n  height: auto\n  border: 0 !important\n  border-right: 1px solid #dbe6f8 !important\n  border-radius: 0\n  color: #5f6f88\n  background: linear-gradient(180deg, #f7faff 0%, #f2f6fd 100%)\n  box-shadow: none\n\n  .anticon\n    font-size: 18px\n\n  &:hover,\n  &:focus\n    color: #20baf2 !important\n    background: linear-gradient(180deg, #f4f8ff 0%, #ecf3ff 100%) !important\n\n.searchPanelBaseAnt__input.ant-input\n  border: 0 !important\n  border-radius: 0\n  height: auto\n  min-height: 50px\n  padding: 0 14px\n  font-size: 15px\n  color: #2f415f\n  box-shadow: none !important\n\n  &::placeholder\n    color: #9aa8bc\n    opacity: 1\n\n  &:hover,\n  &:focus\n    border: 0 !important\n    box-shadow: none !important\n\n.searchPanelBaseAnt__config\n  display: inline-flex\n  align-items: stretch\n  border-left: 1px solid #dbe6f8\n  padding: 0\n\n  .catalogControlAnt__iconBtn.ant-btn\n    min-width: 50px\n    height: auto\n    border: 0 !important\n    border-radius: 0\n    box-shadow: none\n    background: linear-gradient(180deg, #f7faff 0%, #f2f6fd 100%)\n\n@media screen and (max-width: 767.98px)\n  .searchPanelBaseAnt__searchBtn.ant-btn\n    min-width: 46px\n\n    .anticon\n      font-size: 16px\n\n  .searchPanelBaseAnt__input.ant-input\n    min-height: 44px\n    padding: 0 12px\n    font-size: 14px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
